module.exports = __webpack_public_path__ + "static/appstore-df406838abcd3afab4a8c37c5d878e77.svg";